import type { Identifier } from '@/components/question/view/types';
import type { AnswerContentSource } from '@/utils/questions/resolveAnswerContentKind';

export const BANK_ID = 'bank';

export type Flow = 'vertical' | 'horizontal';
export type SlotCapacity = 1 | 'multiple';

export type DnDToken = {
  id: Identifier;
  content: AnswerContentSource;
};

export type SlotConfig = {
  id: string;
  capacity?: SlotCapacity;
};

export type Placement = Record<string, Identifier[]>;
